import withDraft from '@/utils/draftHelper';
import actions from '@/collections/constants';
import { updateAuditName } from './state';

const updateCollectionName = withDraft((draft, { code, result: { name } }) => {
  updateAuditName(draft, 'collection', code, name);
});

export default {
  [actions.UPDATE_COLLECTION_SUCCESS]: updateCollectionName,
};
